<script setup>
  import { ref } from "vue";
  import { storeToRefs } from "pinia";
  import { Sparkles } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
  import { useMCampaignActionsStore } from "@stores/mCampaignActions";
  import { useToastsStore } from "@/stores/toastsStore";

  const mCampaignActionsStore = useMCampaignActionsStore();
  const { campaignTargetOptions } = storeToRefs(mCampaignActionsStore);
  const toasts = useToastsStore();

  const busy = ref(false);

  const generate = async (surveyTargetId) => {
    busy.value = true;
    const result = await mCampaignActionsStore.generateQuotaActions(surveyTargetId);
    busy.value = false;
    if (!result) return;

    const title = result.added
      ? `${result.added} action${result.added === 1 ? "" : "s"} added, save to apply`
      : "No new action to add";
    const message = result.warnings.join("\n");
    if (result.warnings.length) toasts.warning(title, message);
    else toasts.success(title);
  };
</script>

<template>
  <template v-if="campaignTargetOptions.length">
    <Button
      v-if="campaignTargetOptions.length === 1"
      variant="ghost"
      class="w-full"
      :disabled="busy"
      data-cy="generate-quota-actions"
      @click="generate(campaignTargetOptions[0].value)">
      <Sparkles />
      Generate from quotas
    </Button>
    <DropdownMenu v-else>
      <DropdownMenuTrigger as-child>
        <Button
          variant="ghost"
          class="w-full"
          :disabled="busy"
          data-cy="generate-quota-actions">
          <Sparkles />
          Generate from quotas
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          v-for="target in campaignTargetOptions"
          :key="target.value"
          @select="generate(target.value)">
          {{ target.label }}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </template>
</template>
